<template>
	<div>
		<el-card shadow="never">
			<div>
				<el-form size="small" :inline="true" label-position="right" label-width="150px" :rules="rules" :model="formData">
					<el-form-item label="车场名称">
						<el-input v-model="formData.parkName" disabled></el-input>
					</el-form-item>

					<el-form-item label="车主类型" prop="userType">
						<dict-select size="small" v-model="formData.userType" placeholder="请选择" :dict="ownerType" @change="handleChange"></dict-select>
					</el-form-item>

					<el-form-item label="车型">
						<dict-select size="small" v-model="formData.carType" :dict="carType" disabled></dict-select>
					</el-form-item>

					<el-form-item label="登记日期">
						<el-date-picker style="width: 200px" v-model="formData.regTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" disabled>
						</el-date-picker>
					</el-form-item>

					<el-form-item label="车牌号" prop="plateNumber">
						<el-input v-model="formData.plateNumber"></el-input>
					</el-form-item>

					<el-form-item label="车主姓名（单位）" prop="userName">
                        <room-select-tree-with-user v-if="formData.userType == 0" v-model="formData.userName" :projectId="formData.projectId" placeholder="请先选择车主类型" :disabled="disabledChooseUserName"></room-select-tree-with-user>
                        <el-input v-if="formData.userType == 1" placeholder="请输入车主姓名（单位）" v-model="formData.userName" :disabled="disabledChooseUserName"></el-input>
					</el-form-item>

					<el-form-item label="联系人" prop="contact">
						<el-input v-model="formData.contact"></el-input>
					</el-form-item>

					<el-form-item label="联系电话" prop="phoneNumber">
						<el-input v-model="formData.phoneNumber"></el-input>
					</el-form-item>

					<el-form-item label="身份证号" prop="idCard">
						<el-input v-model="formData.idCard" placeholder="选填"></el-input>
					</el-form-item>

					<el-form-item label="车主地址" prop="address">
						<el-input v-model="formData.address"></el-input>
					</el-form-item>

					<el-form-item label="备注">
						<el-input
							type="textarea"
							v-model="formData.remarks"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="选填"
							clearable
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSave">登记</el-button>
				<el-button size="small" @click="doClose">关闭</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import "@/assets/scss/common.scss";
import dlgForm from "@/mixin/dlgForm";
import { ownerType, carType } from "@/dict/carDict";
import { idCardValidity } from "@/assets/common/validate";
import RoomSelectTreeWithUser from "@/components/RoomSelectTreeWithUser.vue";
export default {
	name: "NewCarRegistryForm",
	mixins: [dlgForm],
    components: {RoomSelectTreeWithUser},
	data() {
		return {
			ownerType,
			carType,
			rules: {
				userType: [{ required: true, message: "请选择车主类型", trigger: "blur" }],
				plateNumber: [{ required: true, message: "请输入车牌号", trigger: "blur" }],
				userName: [{ required: true, message: "请输入车主姓名", trigger: "blur" }],
				contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
				phoneNumber: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
				address: [{ required: true, message: "请输入车主地址", trigger: "blur" }],
				idCard: [{ validator: idCardValidity, trigger: "blur" }],
			},
		};
	},
	methods: {
		doSave() {
			const url = "/car/web/carManage/card/add";
			this._doSaveForm(this.$refs.form, url, "POST");
		},
        handleChange(newVal) {
            if(newVal == 1) {
                this.formData.userName = '';
            }
        }
	},
   computed: {
        disabledChooseUserName() {
            return this.formData.userType != 0 && this.formData.userType != 1;
        }
    },
	mounted() {
		
	},
};
</script>
<style scoped>
.imageItem {
	display: inherit;
	overflow: hidden;
	width: 150px;
	height: 150px;
	margin-right: 10px;
}
.large >>> .el-form-item__content {
	width: 80%;
	height: 150px;
}

.el-form-item--small >>> .el-form-item__content {
	width: 200px;
}
.el-form-item--small >>> .el-form-item__content .el-input--small {
	width: 200px;
}
.el-input--small >>> .el-input__inner {
	width: 100%;
}
.el-input--small {
	width: 200px;
}
</style>
